const isContrastId = (ids: string[], id: string) => {
  if (ids?.join?.('') === 'all') {
    return true;
  }

  let is_bool = false;
  ids.forEach((item) => {
    if (item.length === 2) {
      const last_id = id.substring(id.length - 2);
      if (last_id === item) {
        is_bool = true;
      }
    } else if (item.length === 1) {
      const last_id = id.substring(id.length - 1);
      if (last_id === item) {
        is_bool = true;
      }
    } else if (item?.toString() === id?.toString()) {
      is_bool = true;
    }
  });
  return is_bool;
};

export const jumpSecurityPage = (uid: string) => {
  const lang = localStorage.BYBIT_LANG_KEY || 'en';
  window.location.href = `/${lang}/security-item-find`;
};
